/**
 * TTS服务商基础类
 *
 * 所有TTS服务必须继承此类
 */

export default class BaseProvider{
    constructor(config={}){
        this.config=config;
        this.onAudio=null;      // 音频数据回调
        this.onComplete=null;   // 当前文本完成回调
        this.onError=null;      // 错误回调
    }

    /**
     * 设置音频回调
     */
    setAudioCallback(callback){
        this.onAudio=callback;
    }

    /**
     * 设置完成回调
     */
    setCompleteCallback(callback){
        this.onComplete=callback;
    }

    /**
     * 设置错误回调
     */
    setErrorCallback(callback){
        this.onError=callback;
    }

    /**
     * 文本转语音
     */
    speak(text){
        throw new Error("Provider必须实现speak方法");
    }

    /**
     * 文本流结束
     */
    finish(){

    }

    /**
     * 是否支持在同一会话里连续输入文本
     */
    isStreaming(){
        return false;
    }

    /**
     * 停止当前任务
     */
    stop(){
        throw new Error("Provider必须实现stop方法");
    }

    /**
     * 关闭连接
     */
    close(){

    }

}
